<canvas *ngIf="!loadError()" (touchstart)="start($event)" (touchmove)="move($event)" (touchend)="end($event)"
  (mousedown)="start($event)" (mousemove)="move($event)" (mouseup)="end($event)" #imgCanvas></canvas>

<div *ngIf="loadError()" class="renderer-center">
  <h4>
    {{operationContext.error.message}}
  </h4>
</div>